import { enqueueSnackbar, UploadFile } from 'actions';
import { GetSiteDownTimeTableRequest, ImportSiteDownTimeFileRequest, ImportTowerDBFileRequest, ImportIncMassivaFileRequest, ImportIncTicketsFileRequest } from '../requests/SiteDownTimeRequests';

export const GET_SITEDOWNTIME_TABLE = 'GET_SITEDOWNTIME_TABLE';
export const TOGGLE_IMPORT_MODAL_VISIBILITY = 'TOGGLE_IMPORT_MODAL_VISIBILITY';

const onGetSiteDownTimeTable = (value) => ({
	type: GET_SITEDOWNTIME_TABLE,
	siteDownTimeTableData: value
});

export const GetSiteDownTimeTable = () => async (dispatch) => {
	await GetSiteDownTimeTableRequest().then(response => {
		dispatch(onGetSiteDownTimeTable(response.data));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

const onToggleImportModalVisibility = (visible) => ({
	type: TOGGLE_IMPORT_MODAL_VISIBILITY,
	importModalVisibility: visible
});

export const ToggleImportModalVisibility = (visible) => (dispatch) => {
	dispatch(onToggleImportModalVisibility(visible));
};

export const ImportSiteDownTimeFile = (userId, filePath) => async (dispatch) => {
	await ImportSiteDownTimeFileRequest(userId, filePath).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ImportTowerDBFile = (userId, filePath) => async (dispatch) => {
	await ImportTowerDBFileRequest(userId, filePath).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ImportIncMassivaFile = (userId, filePath) => async (dispatch) => {
	await ImportIncMassivaFileRequest(userId, filePath).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const ImportIncTicketsFile = (userId, filePath) => async (dispatch) => {
	await ImportIncTicketsFileRequest(userId, filePath).then(response => {
		dispatch(enqueueSnackbar({ message: response.data, options: { variant: 'success' } }));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};

export const UploadSiteDownTimeFiles = (userId, file, title) => async (dispatch) => {
	await UploadFile(file).then(response => {
		if (title === 'DWT') {
			dispatch(ImportSiteDownTimeFile(userId, response.data));
		} else if (title === 'Tower DB') {
			dispatch(ImportTowerDBFile(userId, response.data));
		} else if (title === 'Inc Massiva') {
			dispatch(ImportIncMassivaFile(userId, response.data));
		} else if (title === 'Inc Tickets') {
			dispatch(ImportIncTicketsFile(userId, response.data));
		}
		dispatch(ToggleImportModalVisibility(false));
	}).catch((error) => {
		if (error) {
			dispatch(enqueueSnackbar({ message: error.message, options: { variant: error.variant } }));
		}
	});
};
